import { newSearch } from '../functions/search.js';
import { initCart } from '../functions/cart.js';
import { initPageCarousels } from '../functions/carousel.js';
import { getCacheData, setCacheData } from '../functions/cache.js';

function loadMostSearched() {
  const cacheKey = "most_searched_cache";
  const cacheTTL = 1000 * 60 * 60 * 6;
  const cachedData = getCacheData(cacheKey);
  if (cachedData && Array.isArray(cachedData)) {
    renderMostSearched(cachedData);
    return;
  }
  $.ajax({
    url: "index.php?route=common/most_searched",
    type: "GET",
    dataType: "json",
    success: function (response) {
      if (Array.isArray(response) && response.length) {
        setCacheData(cacheKey, response, cacheTTL);
        renderMostSearched(response);
      }
    },
    error: function (xhr, status, error) {
      console.error("Erro ao buscar termos mais procurados:", error);
    },
  });
}

function renderMostSearched(response) {
  let html = "";
  $(response).each(function (index, item) {
    if (!item.keyword.includes('{search_term_string}')) {
      html += `<a class="most-searched-item btn btn-neutral" href="/busca?search=${item.keyword}">
        ${item.keyword}
      </a>`;
    }
  });

  if (html != '') {
    $(".search__suggestions").html(html);
  }
}

function initHeaderSearch() {
  let debounceTimer;
  let search_request = null;
  const searchElements = {
    searchResultsListElement: "search__results-list",
    searchResultItemTemplate: "search-results-template",
    searchNoResultsTemplate: "search-no-results-template",
    searchLoadingTemplate: "search-loading-template",
  };

  loadMostSearched();

  // Suporta tanto o sistema novo (v2) quanto o antigo
  const $searchField = $("#search-field-v2, #search-field");
  window.initCarousel = initPageCarousels;

  $searchField.off();
  $searchField.on("input", function (e) {
    const query = $(this).val().trim();
    clearTimeout(debounceTimer);

    if (search_request) {
      search_request.abort();
      search_request = null;
    }

    // Mantém a lista vazia para que o estado :empty esconda os resultados.
    if (query.length < 3) {
      $(".pre-search").empty();
      $("#" + searchElements.searchResultsListElement).empty();
      return;
    }

    debounceTimer = setTimeout(() => {
      search_request = newSearch(query, searchElements);
    }, 400);
  });

  // Implementação customizada do toggle (substitui o collapse do Bootstrap)
  $('[data-target=".search__content"]').on("click", function (e) {
    e.preventDefault();
    const $target = $(".search__content");
    const $button = $(this);

    // Toggle da classe show
    $target.toggleClass("show");

    // Atualiza aria-expanded
    const isExpanded = $target.hasClass("show");
    $button.attr("aria-expanded", isExpanded);

    // Foca no campo após abrir
    if (isExpanded) {
      setTimeout(() => {
        $searchField.trigger("focus");
      }, 350);
    }
  });

  // Botão de fechar específico
  $("#close-search").on("click", function () {
    const $target = $(".search__content");
    $target.removeClass("show");
    $('[data-target=".search__content"]').attr("aria-expanded", "false");
  });

  const searchContentTop = $("header").height() + 32;
  $('.search__content').css('top', searchContentTop + 'px');
}

function initScrollDetection(scrollThreshold = 80) {
  let isScrolled = false;

  $(window).on('scroll', function() {
    const scrollTop = $(window).scrollTop();

    if (scrollTop > scrollThreshold && !isScrolled) {

      $('body').addClass('scrolled');
      isScrolled = true;
    } else if (scrollTop <= scrollThreshold && isScrolled) {
      $('body').removeClass('scrolled');
      isScrolled = false;
    }
  });
}

$.initScrollDetection = initScrollDetection;

export function initHeader() {
  try {
    initHeaderSearch();
    initCart();
    initScrollDetection();
  } catch (error) {
    console.error('Erro ao inicializar o sistema de busca no cabeçalho:', error);
  }
}
